import React, { useState, useEffect } from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import "semantic-ui-css/semantic.min.css";
import App from "./App";
import store from "./StateManagement/store";
import { Provider } from "react-redux";
import axiosInstance from "./axios/axios";

import globe_err from "./assets/images/fluent_globe-error.png";
import { Button, Image } from "react-bootstrap";

const root = document.getElementById("root");

const AppContainer = () => {
  const [apiResponse, setApiResponse] = useState(null);
  const token = localStorage.getItem("token");

  function triggerPageLoadActions() {
    loadFavicon();
    loadEssentialResources();
    loadExternalResources();
  }

  // Functions to load resources as needed (same as in index.html)
  function loadFavicon() {
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) return;

    const favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.href = "favicon-vozo.png";
    document.head.appendChild(favicon);
  }

  function loadEssentialResources() {
    // Load React
    const reactScript = document.createElement("script");
    reactScript.src = "https://unpkg.com/react@17/umd/react.production.min.js";
    document.head.appendChild(reactScript);

    // Load ReactDOM
    const reactDomScript = document.createElement("script");
    reactDomScript.src =
      "https://unpkg.com/react-dom@17/umd/react-dom.production.min.js";
    document.head.appendChild(reactDomScript);

    // Load jQuery
    const jqueryScript = document.createElement("script");
    jqueryScript.src =
      "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js";
    document.head.appendChild(jqueryScript);

    // const formioScript = document.createElement("script");
    // formioScript.src = "https://cdn.form.io/formiojs/formio.full.min.js";
    // document.head.appendChild(formioScript);

    const pageScript = document.createElement("script");
    pageScript.src =
      "https://cdn-in.pagesense.io/js/vozo/8dafafca6bba43a5b300c7177946fded.js";
    document.head.appendChild(pageScript);

    const productionScript = document.createElement("script");
    productionScript.src =
      "https://unpkg.com/react@17/umd/react.production.min.js";
    document.head.appendChild(productionScript);
  }

  // Function to load additional resources based on API response
  function loadExternalResources() {
    // Load Font Awesome CSS
    const fontAwesomeLink = document.createElement("link");
    fontAwesomeLink.rel = "stylesheet";
    fontAwesomeLink.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css";
    document.head.appendChild(fontAwesomeLink);

    // Load Apple Touch Icon
    const appleTouchIconLink = document.createElement("link");
    appleTouchIconLink.rel = "apple-touch-icon";
    appleTouchIconLink.href = "%PUBLIC_URL%/logo192.png";
    document.head.appendChild(appleTouchIconLink);

    // const formLink = document.createElement("link");
    // formLink.rel = "stylesheet";
    // formLink.href =
    //   "https://unpkg.com/formiojs@latest/dist/formio.full.min.css";
    // document.head.appendChild(formLink);

    // const bootStrapLink = document.createElement("link");
    // bootStrapLink.rel = "stylesheet";
    // bootStrapLink.href =
    //   "https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css";
    // document.head.appendChild(bootStrapLink);

    // const formioLink = document.createElement("link");
    // formioLink.rel = "stylesheet";
    // formioLink.href = "https://cdn.form.io/formiojs/formio.full.min.css";
    // document.head.appendChild(formioLink);
  }

  // Function to load the Clarity tracking script lazily with type="text/javascript"
  function loadClarityTracking() {
    if (window.clarity) {
      return;
    }

    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

    const scriptElement = document.createElement("script");
    scriptElement.async = true;
    scriptElement.src = "https://www.clarity.ms/tag/nv7yzev35o";

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(scriptElement, firstScript);
  }

  const buttonStyle = {
    border: 0,
    borderRadius: "20px",
    boxSizing: "border-box",
    color: "#fff",
    cursor: "pointer",
    fontSize: ".875em",
    margin: 0,
    padding: "8px 16px",
    transition: "box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1)",
    background: "blue",
    userSelect: "none",
    marginTop: "50px",
  };

  useEffect(() => {
    const fetchTransferData = async () => {
      // const checkPath = "api/vozo/transfer";

      //       /api/vozo/transfer  =======> Before login page
      //        /vozo/transfer      =======> After login

      let checkPath = "api/vozo/transfer";

      console.log(axiosInstance.defaults.baseURL);

      if (
        axiosInstance.defaults.baseURL?.endsWith("/api") &&
        checkPath.startsWith("api/")
      ) {
        checkPath = checkPath.replace(/^api\//, "");
      }

      try {
        const response = await axiosInstance.get(checkPath);
        setApiResponse(response.data);
        if (parseInt(response.data) === 1) {
          loadClarityTracking();

          // 👉 if user already logged in, run extra actions
          if (token) {
            triggerPageLoadActions();
          }
        }
      } catch (error) {
        console.error("API call failed:", error);
        setApiResponse(0);
      }
    };

    fetchTransferData();
  }, []);

  if (apiResponse === 0) {
    return (
      <div
        style={{ textAlign: "left", marginTop: "50px", marginLeft: "300px" }}
      >
        <Image
          src={globe_err}
          height={70}
          width={70}
          style={{ marginBottom: "20px" }}
        ></Image>

        <h2>403 Forbidden</h2>
        <p>You do not have permission to access this application.</p>
        <Button onClick={() => window.location.reload()} style={buttonStyle}>
          Reload
        </Button>
      </div>
    );
  }

  // If API response is valid (not 0), render the main app
  return (
    // apiResponse === 1 && (
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
    // )
  );
};

// Rendering the AppContainer instead of App directly
render(<AppContainer />, root);
